//side nav functions

document.addEventListener('click', function (event) {
    var sideNav = document.getElementsByClassName('sideNav')[0];
    var sideNavButton = document.getElementById('sideNavButton');
    var cartButton = document.getElementsByClassName('cart')[0];
    var cartButtonOnScroll = document.getElementsByClassName('section-cart')[0];
    var fixedToggleSidenavButton = document.getElementById('s-n-toggle');

    if (!sideNav.contains(event.target) && !sideNavButton.contains(event.target)
        && !cartButton.contains(event.target) && !fixedToggleSidenavButton.contains(event.target)) {
        if (cartButtonOnScroll) {
            if (!cartButtonOnScroll.contains(event.target)) {
                closeSideNav();
            }
        }
        else {
            closeSideNav();
        }
    }
});
function showSideNavMenu(className) {
    var targetMenu = document.getElementsByClassName(className)[0];
    var sideNavSection = document.getElementsByClassName('sideNavSections')[0];
    var sideNavCart = document.getElementsByClassName('sideNavCart')[0];
    var activeOrders = document.getElementsByClassName('activeOrders')[0];
    var ordersHistory = document.getElementsByClassName('ordersHistory')[0];
    var loginSection = document.getElementsByClassName('login-section')[0];
    var myAccount = document.getElementsByClassName('sideNavAccount')[0];
    var sideNavMenu = document.getElementsByClassName('bottom')[0];
    var sideNavCatalogs = document.getElementsByClassName('sideNavCatalogs')[0];

    //submenus
    var mainAccountForm = document.getElementsByClassName('account-form')[0];
    var phonesConfigMenu = document.getElementsByClassName('phone-config-menu')[0];
    var locationsConfigMenu = document.getElementsByClassName('location-config-menu')[0];
    var verifPhoneMenu = document.getElementsByClassName('verif-phone-menu')[0];
    var facturacionConfigMenu = document.getElementsByClassName('facturation-config-menu')[0];

    if (sideNavSection) {
        sideNavSection.style.display = 'none';
    }
    if (sideNavCart) {
        sideNavCart.style.display = 'none';
    }
    if (activeOrders) {
        activeOrders.style.display = 'none';
    }
    if (ordersHistory) {
        ordersHistory.style.display = 'none';
    }
    if (loginSection) {
        loginSection.style.display = 'none';
    }
    if (sideNavMenu) {
        sideNavMenu.style.display = 'none';
    }
    if (myAccount) {
        myAccount.style.display = 'none';
    }
    if (sideNavCatalogs) {
        sideNavCatalogs.style.display = 'none';
    }
    if (phonesConfigMenu) {
        phonesConfigMenu.style.display = 'none';
    }
    if (locationsConfigMenu) {
        locationsConfigMenu.style.display = 'none';
    }
    if (verifPhoneMenu) {
        verifPhoneMenu.style.display = 'none';
    }
    if (facturacionConfigMenu) {
        facturacionConfigMenu.style.display = 'none';
    }

    //submenu
    if (className == 'phone-config-menu' || className == 'location-config-menu' || className == 'verif-phone-menu' || className == 'facturation-config-menu') {
        mainAccountForm.style.display = 'none';
        myAccount.style.display = 'flex';
    }

    if (targetMenu) {
        targetMenu.style.display = 'flex';
    }
}
function getBack() {
    var sideNavSection = document.getElementsByClassName('sideNavSections')[0];
    var sideNavCart = document.getElementsByClassName('sideNavCart')[0];
    var sideNavMenu = document.getElementsByClassName('bottom')[0];
    var ordersHistory = document.getElementsByClassName('ordersHistory')[0];
    var loginSection = document.getElementsByClassName('login-section')[0];
    var myAccount = document.getElementsByClassName('sideNavAccount')[0];
    var sideNavCatalogs = document.getElementsByClassName('sideNavCatalogs')[0];

    //submenus
    var mainAccountForm = document.getElementsByClassName('account-form')[0];
    var phonesConfigMenu = document.getElementsByClassName('phone-config-menu')[0];
    var locationsConfigMenu = document.getElementsByClassName('location-config-menu')[0];
    var verifPhoneMenu = document.getElementsByClassName('verif-phone-menu')[0];
    var facturacionConfigMenu = document.getElementsByClassName('facturation-config-menu')[0];

    //submenu
    if (phonesConfigMenu.style.display == 'flex' || locationsConfigMenu.style.display == 'flex' || verifPhoneMenu.style.display == 'flex' || facturacionConfigMenu.style.display == 'flex') {
        phonesConfigMenu.style.display = 'none';
        locationsConfigMenu.style.display = 'none';
        verifPhoneMenu.style.display = 'none';
        facturacionConfigMenu.style.display = 'none';

        mainAccountForm.style.display = 'flex';
        myAccount.style.display = 'flex';
    }
    else if (sideNavSection.style.display == 'flex' || sideNavCart.style.display == 'flex' || loginSection.style.display == 'flex' || ordersHistory.style.display == 'flex' || myAccount.style.display == 'flex' || sideNavCatalogs.style.display == 'flex') {
        if (sideNavSection) {
            sideNavSection.style.display = 'none';
        }
        if (sideNavCart) {
            sideNavCart.style.display = 'none';
        }
        if (ordersHistory) {
            ordersHistory.style.display = 'none';
        }
        if (loginSection) {
            loginSection.style.display = 'none';
        }
        if (myAccount) {
            myAccount.style.display = 'none';
        }
        if (sideNavCatalogs) {
            sideNavCatalogs.style.display = 'none';
        }
        if (sideNavMenu) {
            sideNavMenu.style.display = 'flex';
        }
    }
    else {
        sideNavMenu.style.display = 'flex';
        closeSideNav();
    }
}
function openSideNav() {
    document.getElementsByClassName('sideNav')[0].style.minWidth = '350px';
    document.getElementsByClassName('sideNav')[0].style.width = 'auto';
    document.getElementsByClassName('sideNav')[0].style.boxShadow = "0 0 0 max(100vh, 100vw) rgba(0, 0, 0, .3)";
}
function closeSideNav() {
    document.getElementsByClassName('sideNav')[0].style.minWidth = '0';
    document.getElementsByClassName('sideNav')[0].style.width = '0';
    document.getElementsByClassName('sideNav')[0].style.boxShadow = '';
}
function openSideNavCart() {
    openSideNav();
    showSideNavMenu('sideNavCart');
}
function openSideNavSections() {
    openSideNav();
    showSideNavMenu('sideNavSections');
}

//filters in sidenav
$('#histoOrderSearch').keyup(function () {
    var valThis = $(this).val().toLowerCase();
    if (valThis == "") {
        $('.activeorder').show();
    } else {
        $('.activeorder').each(function () {
            var text = $(this).text().toLowerCase();
            (text.indexOf(valThis) >= 0) ? $(this).show() : $(this).hide();
        });
    };
});
$('#cartSearch').keyup(function () {
    var valThis = $(this).val().toLowerCase();
    if (valThis == "") {
        $('.cart-product').show();
    } else {
        $('.cart-product').each(function () {
            var text = $(this).text().toLowerCase();
            (text.indexOf(valThis) >= 0) ? $(this).show() : $(this).hide();
        });
    };
});

//function add catalog to fav
function toggleFavCatalog(TableID, ClientID) {

}

//login parameters
function togglePasswordView(el) {
    var x = document.getElementById("loginPasswordUser");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}
function toggleLogInView(classname, el) {
    var logClientForm = document.getElementsByClassName('clientClass')[0];
    var logUserForm = document.getElementsByClassName('userClasss')[0];
    var targetForm = document.getElementsByClassName(classname)[0];
    logClientForm.style.display = 'none';
    logUserForm.style.display = 'none';
    targetForm.style.display = 'block';
    //el.classList.add('activeOption');
}
function toggleLogInViewDetail(classname) {
    var createNewClientForm = document.getElementsByClassName('newClientForm')[0];
    var logExistingClientForm = document.getElementsByClassName('clientForm')[0];
    var createNewClientFormStepTwo = document.getElementsByClassName('finalInputs')[0];
    var createNewClientFormStepOne = document.getElementsByClassName('inputs')[0];
    var targetForm = document.getElementsByClassName(classname)[0];

    if (createNewClientFormStepTwo.style.display == 'block') {
        createNewClientFormStepOne.style.display = 'block';
        createNewClientFormStepTwo.style.display = 'none';
        document.getElementById('nextStepNewClientButton').style.display = 'block';
        document.getElementById('registerNewClientButton').style.display = 'none';
    }
    else {
        createNewClientForm.style.display = 'none';
        logExistingClientForm.style.display = 'none';
        targetForm.style.display = 'block';
    }
}

function updateProfilePicture() {
    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=UpdateProfilePicture",
        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        cache: false,
        data: new FormData($('form')[0]),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result != "ERROR") {
                showToast("Impágen actualizada", "success", 3000);
                document.getElementById('profilePic').src = result;
                document.getElementById('mainProfilePic').src = result;
            }
            else {
                showToast("Ocurrió un  error", "warning", 3000);
                console.log(result);
            }
        },
        error: function (result) {
            showToast("Ocurrió un  error", "warning", 3000);
            console.log(result);
        }
    })).done(function () {

    })
}
function updateUserInformation(element, automaticUpdate = false) {
    var fullNameElement = document.getElementsByName('Name')[0];
    if (!isFullName(fullNameElement.value)) {
        showToast("Ingresa tu nombre completo", "warning", 3000);
        fullNameElement.classList.add('a-row-invalid-param');
        return;
    }


    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=UpdateClientInformation&AutomaticUpdate=" + automaticUpdate,
        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        cache: false,
        data: new FormData($('form')[0]),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result.success == true) {
                if (result.validationRequired == true) {
                    if (result.description == "Phone number was modified") {
                        sendNotifiactionToStorage(1, 'Deber verificar nuevamente el telefono');
                    }
                    window.location.reload();
                }
                else {
                    showToast("Cambios guardados", "success", 3000);
                }
            }
            else {
                showToast("Ocurrio un  error", "warning", 3000);
            }
        },
        error: function (result) {
            showToast("Ocurrio un  error", "warning", 3000);
        }
    })).done(function () {

    })
}
function checkClientLogin(el) {
    var input = document.getElementById('loginMail');
    if (input.value == "" || input.value == null) {
        input.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return false;
    }

    $.when($.ajax({
        type: "POST",
        url: apiPath + "/Login?handler=ClientExists&p=" + input.value,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result == true) {
                //submit
                $(".clientForm").submit();
            }
            else {
                input.parentElement.style.borderColor = 'rgb(255, 92, 92)';
                return false;
            }
        },
        error: function (result) {
            console.log(result);
        }
    })).done(function () {

    })
}
function checkUserLogin(el) {
    var input = document.getElementById('loginMailUser');
    var password = document.getElementById('loginPasswordUser');
    if (input.value == "" || input.value == null) {
        input.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return false;
    }
    if (password.value == "" || password.value == null) {
        password.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return false;
    }

    var data = { "Parameter": input.value, "Password": password.value }

    $.when($.ajax({
        type: "POST",
        url: apiPath + "/Login?handler=UserExists",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result == true) {
                window.location.href = `${scriptPath}/Login?a=${input.value}&b=${password.value}`
            }
            else {
                input.parentElement.style.borderColor = 'rgb(255, 92, 92)';
                password.parentElement.style.borderColor = 'rgb(255, 92, 92)';
                return false;
            }
        },
        error: function (result) {
            console.log(result);
        }
    })).done(function () {

    })
}
function checkNewClient(el) {
    var Email = document.getElementById('newClientMail');
    var Phone = document.getElementById('newClientPhone');
    var Name = document.getElementById('newClientName');
    //if order with no register applied
    var ClientID = getCookie('5zL3OaitdNxu');

    if (Email.value == "" || Email.value == null) {
        Email.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return;
    }
    if (!validateEmail(Email.value)) {
        Email.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        document.getElementById('newClientMessageInfo').innerText = 'Escribí un correo electrónico válido';
        return;
    }

    if (Name.value == "" || Name.value == null || Name.value.length < 4) {
        document.getElementById('newClientMessageInfo').innerText = 'Escribí un nombre válido';
        Name.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return;
    }

    if (Phone.value == "" || Phone.value == null || Phone.value.length < 6) {
        document.getElementById('newClientMessageInfo').innerText = 'Escribí un número telefónico válido';
        Phone.parentElement.style.borderColor = 'rgb(255, 92, 92)';
        return;
    }

    $.when($.ajax({
        type: "POST",
        url: apiPath + "/Login?handler=ClientExists&p=" + Email.value + '&y=' + ClientID,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result == true) {
                document.getElementById('newClientMessageInfo').innerText = 'Ya existe un usuario con ese correo';
                Email.parentElement.style.borderColor = 'rgb(255, 92, 92)';
            }
            else {
                //show additional info
                document.getElementsByClassName('inputs')[0].style.display = 'none';
                document.getElementsByClassName('finalInputs')[0].style.display = 'block';
                document.getElementById('nextStepNewClientButton').style.display = 'none';
                document.getElementById('registerNewClientButton').style.display = 'block';
            }
        },
        error: function (result) {
            console.log(result);
        }
    })).done(function () {

    })
}
function registerNewClient(el) {
    var Email = document.getElementById('newClientMail');
    var Name = document.getElementById('newClientName');
    var Phone = document.getElementById('newClientPhone');
    var Office = document.getElementById('newClientOffice');
    //if order with no register applied
    var ClientID = getCookie('5zL3OaitdNxu');

    //mandatory fields
    if (Email.value == "" || Email.value == null) { Email.parentElement.style.borderColor = 'rgb(255, 92, 92)'; return; }
    if (Name.value == "" || Name.value == null) { Name.parentElement.style.borderColor = 'rgb(255, 92, 92)'; return; }
    if (Phone.value == "" || Phone.value == null) { Phone.parentElement.style.borderColor = 'rgb(255, 92, 92)'; return; }

    var data = { "Email": Email.value, "Name": Name.value, "Phone": Phone.value, "ClientID": ClientID, "CommerceName": Office.value }

    $.when($.ajax({
        type: "POST",
        url: apiPath + "/Login?handler=RegisterNewClient",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result != 'ERROR' && result.length > 1 && result != false) {
                //append the clientid
                $(".newClientForm").append(`<input type="hidden" name="x" value="${result}" />`);
                //execute the post method
                $(".newClientForm").submit();
            }
            else {
                console.log(result);
            }
        },
        error: function (result) {
            console.log(result);
        }
    })).done(function () {

    })
}

//misc
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    else return '';
}
function restoreColor(element) {
    element.parentElement.style.borderColor = 'rgb(197, 197, 197)';
}
function updateCartAmmount(element, TableID, ClientID, ProductID, SectionID, AttributeOne, IndexValue) {
    var priceElement = document.getElementById(IndexValue + '-price');
    priceElement.classList.add('blurryPrice');

    var data = {
        "ProductID": ProductID, "TableID": TableID, "SectionID": SectionID,
        Ammount: element.value, "AttributeOne": AttributeOne, "Index": IndexValue
    }

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home/Cart?handler=UpdateAmmount",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            priceElement.innerText = '';
            priceElement.innerText = result;
            priceElement.classList.remove('blurryPrice');
            showToast("Cantidad actualizada", "info", 3000);

            getTotals();
        },
        error: function (result) {
            showToast("Error al modificar el carrito", "warning", 3000);
        }
    })).done(function () {

    })
}
function deleteProductFromCart(TableID, ClientID, ProductID, IndexValue, cartPage) {
    var productCard = document.getElementById(IndexValue + '-card');

    var data = {
        "ProductID": ProductID, "TableID": TableID, "Index": IndexValue
    }

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home/Cart?handler=DeleteProductFromCart",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result) {
                showToast("Producto removido", "info", 3000);
                getTotals();

                productCard.classList.add("removed");
                setTimeout(() => {
                    productCard.remove();
                }, 300);

                var cartCount = document.getElementById('cart-ammount');
                var cartCount2 = document.getElementById('cart-ammount-2');
                var cartCount3 = document.getElementById('cart-ammount-3');
                if (cartCount) {
                    cartCount.innerText = parseInt(cartCount.innerText) - 1;
                }
                if (cartCount2) {
                    cartCount2.innerText = parseInt(cartCount2.innerText) - 1;
                }
                if (cartCount3) {
                    cartCount3.innerText = parseInt(cartCount3.innerText) - 1;
                }

                if (parseInt(cartCount.innerText) <= 0) {
                    document.getElementsByClassName('checkout-btn-div')[0].style.display = 'none';
                }
                else {
                    document.getElementsByClassName('checkout-btn-div')[0].style.display = 'flex';
                }

                if (cartPage.length > 0) {
                    sendNotifiactionToStorage(1, "Producto removido del carrito");
                    location.reload();
                }
                else {
                    sendNotifiactionToStorage(3, "Ocurrió un error");
                }
            }
        },
        error: function (result) {
            showToast("Error al modificar el carrito", "warning", 3000);
        }
    })).done(function () {

    })
}
function getTotals() {
    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home/Cart?handler=GetTotals&tableid=" + TableID,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            document.getElementById('cart_total_price').innerText = result.total;
        },
        error: function () {
        }
    }))
}

function showDeleteButton(index) {
    var button = document.getElementById('deleteButton-' + index);
    button.style.width = '50px';
}
function hideDeleteButton(index) {
    var button = document.getElementById('deleteButton-' + index);
    button.style.width = '0px';
}



//PHONE VERIFICATION
function sendPhoneVerificationMessage() {
    var phoneNumber = document.getElementById('client-phoneNumber').value;
    var prefixNumber = document.getElementById('phoneNumber-prefix').value;

    if (prefixNumber == "" || phoneNumber.length < 8) {
        showToast("Escribi un numero valido", "info", 3000);
        return;
    }

    $.when($.ajax({
        type: "POST",
        url: apiPath + `/Home?handler=VerifyPhoneNumber&Phone=${prefixNumber}${phoneNumber}&Action=0`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result.description == "Message sent") {
                showToast('Mensaje de verificacion enviado', 'info', 3000);
            }
        },
        error: function (result) {
            showToast("No pudimos enviar el mensaje de verificacion", "warning", 3000);
        }
    })).done(function () {
    })
}
function verifyTokenPhoneNumber() {
    var box1 = document.getElementById('pc-char1');
    var box2 = document.getElementById('pc-char2');
    var box3 = document.getElementById('pc-char3');
    var box4 = document.getElementById('pc-char4');
    var inputToken = box1.value + box2.value + box3.value + box4.value;

    if (inputToken.length < 4) {
        return;
    }

    $.when($.ajax({
        type: "POST",
        url: apiPath + `/Home?handler=VerifyPhoneNumber&InputToken=${inputToken}&Action=1`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result.verified == true) {
                updateUserInformation(null, true);
                sendNotifiactionToStorage(0, "Numero de telefono verificado");
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            }
            else {
                if (result.description == "No token found for your account") {
                    showToast("No te enviamos ningun codigo aun", "info", 3000);
                }
                else if (result.description == "Token expired") {
                    showToast("El codigo ha expirado", "warning", 3000);
                }
                else if (result.description == "Incorrect token") {
                    showToast("El codigo ingresado no es correcto", "warning", 3000);
                }
                else {
                    showToast("Ocurrió un error", "warning", 3000);
                }
            }
        },
        error: function (result) {
            showToast("No pudimos enviar el mensaje de verificacion", "warning", 3000);
        }
    })).done(function () {
    })
}
function focusNextBox(box) {
    var box1 = document.getElementById('pc-char1');
    var box2 = document.getElementById('pc-char2');
    var box3 = document.getElementById('pc-char3');
    var box4 = document.getElementById('pc-char4');

    switch (box) {
        case "1":
            box1.focus();
            break;
        case "2":
            box2.focus();
            break;
        case "3":
            box3.focus();
            break;
        case "4":
            box4.focus();
            break;
    }
}
//Avoid 0 as first char
const phoneNumberInput = document.getElementById("client-phoneNumber");
phoneNumberInput.addEventListener("input", () => {
    if (phoneNumberInput.value.length === 1 && phoneNumberInput.value === "0") {
        phoneNumberInput.value = "";
    }
});








//FACTURACION MENU
function getDatosFacturacion() {
    var cuit = document.getElementById('arca-cuit').value.replaceAll('-', '');
    if (cuit.length == 0) {
        return;
    }
    if (cuit.length < 11) {
        showToast("El CUIT ingresado no es valido", "warning", 3000);
        return;
    }

    $.when($.ajax({
        type: "GET",
        url: apiPath + `/API/External/Arca/GetPersona?CUIT=${cuit}`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result != null) {
                document.getElementById('arca-razonsocial').value = result.razonSocial;
                document.getElementById('arca-actividad').value = result.actividad;
                document.getElementById('arca-tipopersona').value = result.tipoPersona;
                document.getElementById('arca-domicilio').value = result.domicilio.direccion + ", " + result.domicilio.provincia;
                document.getElementById('arca-tipodomicilio').value = result.domicilio.tipoDomicilio;
            }
        },
        error: function (result) {
            showToast("No pudimos obtener los datos de facturacion", "warning", 3000);
        }
    })).done(function () {
    })
}
function saveDataFacturation() {
    var cuit = document.getElementById('arca-cuit').value;
    var condicionIva = document.getElementById('arca-condicioniva').value;

    $.when($.ajax({
        type: "POST",
        url: apiPath + `/API/External/Arca/SaveDataFacturation?CUIT=${cuit}&IVA=${condicionIva}`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result) {
                showToast("Informacion fiscal actualizada", "success", 3000);
            }
            else {
                showToast("No pudimos actualizar la informacion", "warning", 3000);
            }
        },
        error: function (result) {
            showToast("No pudimos actualizar la informacion", "warning", 3000);
        }
    })).done(function () {
    })
}

$(document).ready(function () {
    getTotals();

    //normalize phone number input dynamically
    $('#client-phoneNumber').on('input', function () {
        const prefix = $('#phoneNumber-prefix').val().replace(/[\s\-\(\)]/g, '');
        let phone = $(this).val();

        phone = phone.replace(/[+\-\s\(\)]/g, '');

        if (phone.startsWith(prefix.replace('+', ''))) {
            phone = phone.substring(prefix.length - 1); // -1 porque sacamos el "+"
        }

        $(this).val(phone);
    });
});